const aaa = [
	
	{
		path: "guoqiWarningList",
		component: () => import("@/views/kucun/guoqiWarning/list.vue"),
		meta:{title:'过期预警',keepAlive:false},
	},
	{
		path: "guoqiWarningAdd",
		component: () => import("@/views/kucun/guoqiWarning/add.vue"),
		meta:{title:'过期预警'},
	},
	{
		path: "guoqiWarningEdit",
		component: () => import("@/views/kucun/guoqiWarning/edit.vue"),
		meta:{title:'过期预警'},
	},
	{
		path: "guoqiWarningSee",
		component: () => import("@/views/kucun/guoqiWarning/see.vue"),
		meta:{title:'过期预警'},
	}

	
]
export default aaa;